import { render, staticRenderFns } from "./editGroupRobotModal.vue?vue&type=template&id=45205c40&scoped=true&"
import script from "./editGroupRobotModal.vue?vue&type=script&lang=ts&"
export * from "./editGroupRobotModal.vue?vue&type=script&lang=ts&"
import style0 from "./editGroupRobotModal.vue?vue&type=style&index=0&id=45205c40&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45205c40",
  null
  
)

export default component.exports